module.exports = __webpack_public_path__ + "static/img/sf-01.9f7d765.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/sf-01.png
// module id = ySaO
// module chunks = 2